var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v("修改全局数据页面")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.update}},[_vm._v("更新姓名")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }